<div [routerLink]="routerLink">
    <img [src]="imageSrc" *ngIf="imageSrc">
    <span *ngIf="!imageSrc" style="width: 22px;"></span>
    <ng-content></ng-content>
</div>